import React from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { AppState, RedirectLoginOptions } from "@auth0/auth0-react";

import { appName, startFromAccordion } from "../../config";
import { valueFromLocalStorage } from "../../utils/helpers";

const LoginContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  align-content: center;
  margin-top: 15%;
  button {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    align-content: center;
    gap: 0.25rem;
    img {
      margin-right: 0.5rem;
      width: 3rem;
      height: 3rem;
    }
  }
`;

const LoginComponent = ({
  loginWithRedirect,
}: {
  loginWithRedirect: (options?: RedirectLoginOptions<AppState> | undefined) => Promise<void>;
}): JSX.Element => {
  const { t } = useTranslation();

  //* Only Local Storage!
  const isStartingFromAccordion: boolean = valueFromLocalStorage("isStartingFromAccordion")
    ? JSON.parse(valueFromLocalStorage("isStartingFromAccordion") as string)
    : startFromAccordion;

  const handleLogin = async (): Promise<void> => {
    await loginWithRedirect({
      appState: {
        // returnTo: "/",
        returnTo: isStartingFromAccordion ? "/views/accordion" : "/",
      },
    });
  };

  return (
    <React.Fragment>
      {isStartingFromAccordion === false || isStartingFromAccordion === true ? (
        <LoginContainer>
          <Button onClick={handleLogin} variant={"primary"} size="lg">
            <img src={window.location.origin + "/bus.svg"} alt="Bus icon" />
            {t("Zaloguj się do")} <span className="span_bold">{appName}</span>
          </Button>
        </LoginContainer>
      ) : null}
    </React.Fragment>
  );
};

export default LoginComponent;
